import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Esito } from 'src/app/common/models/esito';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { SezioneEsitiFull } from 'src/app/common/models/sezioni/sezione-esiti-full';
import { EsitiLiquidatiAddComponent } from './esiti-add-liquidati.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
  selector: '[mod-esiti-liquidati-add]',
  templateUrl: './esiti-add-liquidati-mod.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})
export class EsitiAddLiquidatiModComponent {

  @Output() onReturn: EventEmitter<SezioneEsitiFull> = new EventEmitter<SezioneEsitiFull>();
  @ViewChild('formLiquidatiAdd') formLiquidati: EsitiLiquidatiAddComponent;
  esito: Esito = new Esito();
  @Input() liquidati: any;
  inizializza(urlUpdate:string, sezione: SezioneEsitiFull, esito: Esito, fascicolo: FascicoloFull, inserimento: boolean, urlReadClassificazioni: string, idSezioneClassificazioni: string, urlSezioneAltreParti: string, 
    idSezioneAltreParti: string, urlSezioneLegali:string, idSezioneLegali:string) {
    this.formLiquidati.inizializza(urlUpdate, sezione, esito, fascicolo, inserimento, urlReadClassificazioni, idSezioneClassificazioni, urlSezioneAltreParti, idSezioneAltreParti, urlSezioneLegali,idSezioneLegali);
    openModal('modaladdliquidati');
  }

  createForm() {
    this.formLiquidati.chiudiModale();
  }


  manageModal() {
      closeModal('modaladdliquidati');
      this.onReturn.emit();
  }

}
